const endpoints = {
  getPartnerSections: 'api/v2/partners_sections/',
  getPartnerSectionContent: ({ sectionId }: { sectionId: number | string }) => `api/v2/partners_sections/${sectionId}/content/`,
}

export default endpoints
